/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsEGameOrientation } from './FxIdDomainSettingsEGameOrientation';
import {
    instanceOfFxIdDomainSettingsEGameOrientation,
    FxIdDomainSettingsEGameOrientationFromJSON,
    FxIdDomainSettingsEGameOrientationFromJSONTyped,
    FxIdDomainSettingsEGameOrientationToJSON,
} from './FxIdDomainSettingsEGameOrientation';

/**
 * @type FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientation
 * Данное свойство устарело. Используйте GameOrientation.
 * @export
 */
export type FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientation = FxIdDomainSettingsEGameOrientation;

export function FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationFromJSON(json: any): FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientation {
    return FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientation {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsEGameOrientation(json)) {
        return FxIdDomainSettingsEGameOrientationFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientationToJSONTyped(value?: FxIdApplicationPublicDataBuilderPublicDataBaseMobileGameOrientation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsEGameOrientation(value)) {
        return FxIdDomainSettingsEGameOrientationToJSON(value as FxIdDomainSettingsEGameOrientation);
    }

    return {};
}

